import React, { useEffect } from "react";
import "./style.css";
import {
  Layout,
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Upload,
  Radio,
  Select,
  Spin,
  InputNumber,
} from "antd";
import {
  CameraOutlined,
  LoadingOutlined,
  UserOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import Container from "../Layout/Container";
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { editUser, getRolesByUserTypeAsyn, editForUserAbilityCaseAsyn, clearEditForUserAbilityCaseSuccess, getUserEditAbilityAsyn, getDepartmentInfoAsyn, clearState, clearStateSuccess, editUserSelector, getUserInfoAsyn, clearStateUserSuccess, clearOnlyUserEditAbilitySuccess } from './editUserSlice'
import MaskedInput from 'antd-mask-input'
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const CheckboxGroup = Checkbox.Group;



const assignPermissionTabOptions = [
  "Upload/Download Multiple Document",
  "Seen Stamp",
  "Add Document",
  "Print Document",
  "File Document",
  "Append Signature",
  "Initiate Ad Hoc Process"
];

const defaultCheckedList = ["Upload/Download Multiple Document", "Add Document", "Append Signature", "Seen Stamp", "Print Document"];

export default function EditUser() {
  const { Option } = Select;
  const [form] = Form.useForm()
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();

  const { isFetching, isSuccess, isError, errorMessage, userEditData, isUserEditDataSucess, UserEditAbility, isUserEditAbilitySucess, roles, departmentInfo, isEditUserSuccess, isUserinfosuccess, userInfo } = useSelector(
    editUserSelector
  );

  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [userinfo, setUserInfo] = React.useState({});

  const [checkedList, setCheckedList] = React.useState(defaultCheckedList);
  const [loading, setloading] = React.useState(false);
  const [imageUrl, setimageUrl] = React.useState("");
  const [fileList, setfileList] = React.useState([]);

  const [directorateval, setDirectorateVal] = React.useState("");
  const [directoratesOption, setDirectorates] = React.useState([]);
  const [usertype, setUserType] = React.useState("");
  const [role, setRole] = React.useState("");

  const [departmentType, setDepartment] = React.useState(userInfo.departmentType);
  const [hideSubmitBtn, sethideSubmitBtn] = React.useState(true);
  const [disbaledRemaningItems, setdisbaledRemaningItems] = React.useState(false);

  useEffect(() => {
    setToast(false);
    dispatch(clearState());
    dispatch(getUserEditAbilityAsyn(location.state.username))
    dispatch(getUserInfoAsyn(location.state.username));
    // dispatch(getRolesByUserTypeAsyn('Clerk'));
    dispatch(getDepartmentInfoAsyn())
    // setTimeout(() => {
    //   setDirectorate(true);
    // }, 5000);

  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }

    if (isUserEditAbilitySucess) {
      // console.log("newlyCreated= ", UserEditAbility.newlyCreated);
      // console.log("filed= ", UserEditAbility.filed);
      if (UserEditAbility.hasOwnProperty('filed') && UserEditAbility.filed === false && UserEditAbility.newlyCreated === false) {
        // setdisbaledRemaningItems(true);
        sethideSubmitBtn(false);
      }


      // if (UserEditAbility.newlyCreated === false && UserEditAbility.filed === false) {
      //   sethideSubmitBtn(false);
      // }
      // else if (UserEditAbility.newlyCreated === false && UserEditAbility.filed === true) {
      //   setdisbaledRemaningItems(true);
      // }
      // else if (UserEditAbility.newlyCreated === true && UserEditAbility.filed === false) {
      //   sethideSubmitBtn(true);
      //   setdisbaledRemaningItems(false);
      // }
      dispatch(clearOnlyUserEditAbilitySuccess());
    }

    if (isUserinfosuccess) {
     // console.log(userInfo, "myuserinfo")
      clearStateUserSuccess();
       setTimeout(() => {
      setUserInfo(userInfo);
      let departmentType = 'Branch';

      if (userInfo.parentBranch) {
        departmentType = 'Branch';
        form.setFieldsValue({
          b_name: userInfo.parentBranch
        });

        getDirectorate(userInfo.parentBranch);
        form.setFieldsValue({
          bd_name: userInfo.departmentTypeName
        });

      }
      else {
        departmentType = 'Branch';
        getDirectorate(userInfo.departmentTypeName);
        form.setFieldsValue({
          b_name: userInfo.departmentTypeName
        });
        form.setFieldsValue({
          bd_name: ""
        });
      }


      if (userInfo.departmentType == 'independentOffice') {
        departmentType = "Independent Office";
        form.setFieldsValue({
          io_name: userInfo.departmentTypeName
        });
      }

      if (userInfo.departmentType == 'independentDirectorate') {
        departmentType = "Independent Directorate";
        form.setFieldsValue({
          id_name: userInfo.departmentTypeName
        });
      }

      setDepartment(departmentType);
      let utype = userInfo.type == "DD's & AD's" ? "DD's %26 AD's" : userInfo.type;
      // console.log('userInfo.type')
      // console.log(utype)
      dispatch(getRolesByUserTypeAsyn(utype));

      form.setFieldsValue({
        fullName: userInfo.name,
        username: userInfo.username,
        email: userInfo.email,
        serviceNumber: userInfo.serviceNumber,
        phone: userInfo.phone,
        userType: utype,
        role: userInfo.roleName,
        departmenttype: departmentType,
        departmenttype: departmentType,
        // independentOffice:department.independentOffice,
        // independentDirectorate:department.independentDirectorate,
      });

      if (Array.isArray(userInfo.profilePic) && userInfo.profilePic.length || userInfo.profilePic != '') {
        // console.log('..')
        // console.log(userInfo.profilePic)

        setimageUrl(userInfo.profilePic)
      };

       }, 1000);

    }

    if (isEditUserSuccess) {
      dispatch(clearStateSuccess());
      setLoading(false);
      setToast(true);
      toast.success('User edited successfully');
      history.push('/manage-users');
    }

    if (isUserEditDataSucess) {
      setLoading(false);
      setToast(true);
      if (errorMessage === "User successfully updated") {
        toast.success(errorMessage);
      }
      history.push('/manage-users');
      dispatch(clearEditForUserAbilityCaseSuccess());
    }


  }, [isError, isSuccess, isEditUserSuccess, isUserEditDataSucess, userEditData, setLoading, setToast, isUserinfosuccess, setUserInfo, userInfo, form, setDepartment, getDirectorate, clearStateUserSuccess, getRolesByUserTypeAsyn]);


  const onChange = (list) => {
    setCheckedList(list);
  };

  function handleChange(value) {
    // console.log(`selected ${value}`);
    setRole(value);
    //dispatch(getRolesByUserTypeAsyn(value));
  }

  function setRoles(e) {
    // console.log(`selected ${e.target.value}`);
    setUserType(e.target.value);
    setRole('');
    dispatch(getRolesByUserTypeAsyn(e.target.value));
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleUploadChange = (info) => {
    // console.log(info.fileList)
    if (info.file.status === "uploading" || info.file.status === "done") {
      setloading(true);
      setfileList(info.fileList);
      getBase64(info.file.originFileObj, (imgUrl) => {
        setloading(false);
        setimageUrl(imgUrl);
      });
      return;
    }
  };

  const onFinish = (values) => {
    // console.log(values)

    let formData = new FormData();
    if (values.profilePic) {
      formData.append("profilePic", values.profilePic.fileList[0].originFileObj);
    }

    formData.append("username", values.username);
    formData.append("fullName", values.fullName);
    formData.append("email", values.email);
    //formData.append("serviceNumber", values.serviceNumber);
    //  formData.append("password", values.password);
    //  formData.append("confirmPassword", values.confirmPassword);
    formData.append("phone", values.phone);
    formData.append("userType", values.userType == "DD's %26 AD's" ? "DD's & AD's" : values.userType);
    formData.append("role", values.role);
    formData.append("departmentChange", true);
    formData.append("department", 'Chief of Air Staff');
    if (values.departmenttype == 'Branch') {
      formData.append("branch", values.departmenttype == 'Branch' ? "true" : "false");
      formData.append("b_name", values.b_name ? values.b_name : '');

      formData.append("b_directorate", values.bd_name ? "true" : "false");
      if (values.bd_name !== "" && values.bd_name !== undefined) {
        formData.append("bd_name", values.bd_name ? values.bd_name : '');
        formData.append("bd_parentBranch", values.b_name ? values.b_name : '');
      }
    }

    if (values.departmenttype == 'Independent Office') {
      formData.append("independentOffice", values.departmenttype == "Independent Office" ? true : false);
      formData.append("io_name", values.io_name ? values.io_name : '');
    }

    if (values.departmenttype == 'Independent Directorate') {
      formData.append("independentDirectorate", values.departmenttype == "Independent Directorate" ? true : false);
      formData.append("id_name", values.id_name ? values.id_name : '');
    }

    setloading(true);
    if (disbaledRemaningItems === true) {

      let SomeFields = new FormData();
      if (values.profilePic) {
        SomeFields.append("profilePic", values.profilePic.fileList[0].originFileObj);
      }
      SomeFields.append("username", values.username);
      SomeFields.append("fullName", values.fullName);
      SomeFields.append("userType", values.userType == "DD's %26 AD's" ? "DD's & AD's" : values.userType);
      SomeFields.append("phone", values.phone);
      SomeFields.append("role", values.role);

      dispatch(editForUserAbilityCaseAsyn(SomeFields));
    } else {
      // for (var [key, value] of formData.entries()) {
      //   console.log(key, value);
      // }
      dispatch(editUser(formData));
    }
    // // add one or more of your files in FormData
    // // again, the original file is located at the `originFileObj` key
    // formData.append("file", this.state.fileList[0].originFileObj);


  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };


  const roleOptions = () => {
    const roleOptions = [];

    if (roles.length > 0) {
      roles.map((val, index) => {
        roleOptions.push({ value: val })
      })
    }
    return roleOptions;
  }

  const getBranches = () => {
    const branchOptions = [];
    if (departmentInfo && departmentInfo.branch_data && departmentInfo.branch_data.length > 0) {
      departmentInfo.branch_data.map((val, index) => {
        branchOptions.push({ value: val.b_name })
      })
    }
    return branchOptions;
  }

  function getDirectorate(value) {
    setDirectorates([]);
    // console.log('initialize directorate...');
    // console.log(value)
    setDirectorateVal('');
    let totalBranches = [];
    let totalDirectorates = [{ label: "None", value: "" }];
    if (departmentInfo && departmentInfo.branch_data && departmentInfo.branch_data.length > 0) {
      departmentInfo.branch_data.map((val, index) => {
        totalBranches.push(val)
      })
    }

    if (totalBranches.length > 0) {
      let dir = totalBranches.filter(br => br.b_name == value).map((dr) => {
        return dr.bd_directorates;
      });

      if (dir && dir[0] && dir[0].length > 0) {
        dir[0].map((val, index) => {
          totalDirectorates.push({ value: val.bd_name })
        });
        setDirectorates(totalDirectorates);
      }
    }
    //dispatch(getRolesByUserTypeAsyn(value));
  }

  const setDepartmentType = (e) => {
    // console.log(e.target.value)
    setDepartment(e.target.value);
  }

  const getIndependentOffices = () => {
    const Options = [];
    if (departmentInfo && departmentInfo.io_independentOffices && departmentInfo.io_independentOffices.length > 0) {
      departmentInfo.io_independentOffices.map((val, index) => {
        Options.push({ value: val.io_name })
      })
    }
    return Options;
  }

  const getIndependentDirectorates = () => {
    const Options = [];
    if (departmentInfo && departmentInfo.id_directorates && departmentInfo.id_directorates.length > 0) {
      departmentInfo.id_directorates.map((val, index) => {
        Options.push({ value: val.id_name })
      })
    }
    return Options;
  }
  // console.log(userinfo)
  return (
    <>
      <Container>
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to="/manage-users">Users</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit User</Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <div>
              <Row
                style={{
                  paddingTop: 35,
                  paddingBottom: 20,
                  borderLeft: "1px solid #dfe0eb",
                  borderRight: "1px solid #dfe0eb",
                  borderTop: "1px solid #dfe0eb",
                  borderBottom: "2px solid #e8e8e8",
                  backgroundColor: "#ffffff"
                }}
              >
                <Col span="5"></Col>
                <Col span="18">
                  <h1
                    style={{
                      fontWeight: "bold",
                      fontStyle: "normal",
                      fontSize: 24,
                    }}
                  >
                    Edit User
                  </h1>
                </Col>
                {/* <Col span="9" style={{ paddingLeft: 25 }}></Col> */}
              </Row>
              <Form
                layout="vertical"
                labelCol={{ span: 15 }}
                wrapperCol={{ span: 22 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
                style={{ backgroundColor: "#ffffff" }}
              // fields={[
              //   {
              //     name: ["fullName"],
              //     value: userinfo.name,
              //   },
              // ]}
              >
                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 90,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",

                  }}
                >
                  <Col span="5"></Col>
                  <Col span="16">
                    {/* <Form
                    layout="vertical"
                    labelCol={{ span: 15 }}
                    wrapperCol={{ span: 22 }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                  > */}
                    <Form.Item>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                        }}
                      >
                        User Details
                      </h2>
                    </Form.Item>
                    <Row>
                      <Col span="5"></Col>
                      <Col span="10" id={'profilepicid'}>
                        <Form.Item
                          name="profilePic"
                        //   rules={[
                        //    {
                        //      required: true,
                        //      message: 'Please select profile pic!',
                        //    },
                        //  ]}
                        //   requiredMark={'optional'}
                        >
                          <Upload
                            accept=".jpg,.png,.jpeg"
                            // listType="picture"
                            //name="avatar"
                            listType="picture-card"
                            // className="avatar-uploader"
                            showUploadList={false}
                            // action=""
                            onChange={handleUploadChange}
                          >
                            {imageUrl ? (
                              <>
                                <div style={{ width: 200, height: 200 }}>
                                  <img
                                    src={imageUrl}
                                    alt="avatar"
                                    style={{ width: "100%", height: '100%' }}
                                  />
                                </div>

                                <div style={{ marginTop: 8 }}>
                                  {<CameraOutlined />}
                                </div>
                              </>
                            ) : (
                              <>
                                {loading ? (
                                  <LoadingOutlined />
                                ) : (
                                  <UserOutlined />
                                )}
                                <div style={{ marginTop: 8 }}>
                                  {<CameraOutlined />}
                                </div>
                              </>
                            )}
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span="5"></Col>
                    </Row>
                    <Row>
                      <Col span="22">
                        <Form.Item
                          name="fullName"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter full name!',
                            },
                          ]}
                          requiredMark={'optional'}

                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Full Name*
                            </p>
                          }
                        >
                          <Input
                            className="formInput"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span="2"></Col>
                    </Row>
                    <Row style={{ marginTop: 15 }}>
                      <Col span="10">
                        <Form.Item
                          name="username"
                          initialValue={userinfo.username}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter username!',
                            },
                            {
                              // pattern: new RegExp('^[A-Za-z0-9.]{3,30}$'),
                              // pattern: new RegExp('^[a-zA-Z0-9]+$'),
                              pattern: new RegExp('^[a-z0-9_]{3,30}$'),
                              message: 'Username must be lowercase and contain minimum 3 characters  and maximum 30 characters without any space'
                            }
                            //  ,
                            //   // { max: 15, message: 'Username can have a maximum length of 15' },

                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              User Name*
                            </p>
                          }
                        >
                          <Input
                            disabled={disbaledRemaningItems}
                            className="formInput"
                            placeholder=""
                            maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              type: 'email',
                              message: 'The input is not valid E-mail!',
                            },
                            {
                              required: true,
                              message: 'Please input your E-mail!',
                            },
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Email ID*
                            </p>
                          }
                        >
                          <Input disabled={disbaledRemaningItems} className="formInput" placeholder="" />
                        </Form.Item>
                      </Col>
                      <Col span="11">
                        <Form.Item
                          name="serviceNumber"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter staff/user number!',
                            },
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Staff/User Number*
                            </p>
                          }
                        >
                          <Input
                            className="formInput"
                            placeholder=""
                            maxLength={50}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter contact no!',
                            },
                            // { max: 15, message: 'Username can have a maximum length of 15' },
                            {
                              // pattern: new RegExp('^[0-9]{1,15}$'),
                              // pattern: new RegExp('^[0-9]+$'),
                              //pattern: new RegExp('^\(?+[0-9]{2}(\-|\))-[0-9]{3}-[0-9]{4}-[0-9]{3}$'),
                              //pattern: new RegExp('^[+][0-9](2)-[0-9]{3}-[0-9]{4}-[0-9]{3}$'),
                              // pattern: new RegExp('^[+][0-9]{3}-[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
                              // message: 'Contact number is invalid'
                            }
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Contact No*
                            </p>
                          }
                        >
                          {/* <MaskedInput className="formInput" mask="+111-111-111-1111"  placeholder="+234-119-545-1457" /> */}

                          <Input
                            type={'text'}
                            className="formInput"
                            placeholder=""
                            maxLength={30}
                          // min={1}
                          //  max={15}
                          />
                          {/* <InputNumber
                            className="formInput"
                            placeholder=""
                            min={1} max={15}
                          /> */}
                        </Form.Item>
                      </Col>
                      <Col span="3"></Col>
                    </Row>

                    <Form.Item style={{ marginTop: 25 }}>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                          marginTop: 15,
                        }}
                      >
                        Appointments
                      </h2>
                    </Form.Item>

                    <Form.Item
                      label={
                        <p
                          style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "16px",
                            color: "#6b778c",
                            marginTop: "5px",
                            marginBottom: "0",
                          }}
                        >
                          User Type
                        </p>
                      }
                    >
                      <Form.Item
                        name="userType"
                        rules={[
                          {
                            required: true,
                            message: 'Please choose usertype!',
                          },
                        ]}
                        requiredMark={'optional'}

                      >
                        <Radio.Group disabled={disbaledRemaningItems} defaultValue={usertype} onChange={setRoles}>
                          {/* <Radio style={{ paddingRight: "28px" }} value="Clerk">Clerk</Radio>
                          <Radio style={{ paddingRight: "28px" }} value="DD's %26 AD's"  >DD's & AD's</Radio>
                           */}
                          <Radio style={{ paddingRight: "28px" }} value="CHD" >Standard User</Radio>
                        </Radio.Group>
                      </Form.Item>

                      <Row style={{ marginTop: "30px" }}>
                        {/* <Col span="4"><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Assign Role*</p></Col> */}
                        <Col span="11">
                          <Form.Item
                            name="role"
                            rules={[
                              {
                                required: true,
                                message: 'Please select role!',
                              },
                            ]}
                            requiredMark={'optional'}
                            // noStyle
                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Assign Appointment*</p>}
                          >
                            {/* <Select  onChange={handleChange}> */}
                            <Select defaultValue={role} options={roleOptions()} defaultActiveFirstOption={true} onChange={handleChange}>
                              {/* <Option value="Clerk">Clerk</Option>
                                          <Option value="DD's & AD's">DD's & AD's</Option>
                                          <Option value="CHD">CHD</Option> */}
                            </Select>
                          </Form.Item>
                        </Col>
                        {/* <Col span="1"></Col> */}
                        {/* <Col span="11">
                              <Form.Item
                                        label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Assign Department*</p>}
                                      >
                                          <Select  onChange={handleChange}>
                                          <Option value="Clerk">Clerk</Option>
                                          <Option value="DD's & AD's">DD's & AD's</Option>
                                          <Option value="CHD">CHD</Option>
                                        </Select>
                                      </Form.Item>
                              </Col>
                              <Col span="2"></Col> */}
                      </Row>
                    </Form.Item>



                    <Form.Item style={{ marginTop: 25 }}>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                          marginTop: 15,
                        }}
                      >
                        User Department
                      </h2>
                    </Form.Item>

                    <Form.Item
                      label={
                        <p
                          style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "16px",
                            color: "#6b778c",
                            marginTop: "5px",
                            marginBottom: "0",
                          }}
                        >
                          Department Type
                        </p>
                      }
                    >
                      <Form.Item
                        name="departmenttype"
                        rules={[
                          {
                            required: true,
                            message: 'Please select department type!',
                          },
                        ]}
                        requiredMark={'optional'}
                        initialValue={'Branch'}
                      >
                        <Radio.Group disabled={disbaledRemaningItems} defaultValue={departmentType} onChange={setDepartmentType}>
                          <Radio style={{ paddingRight: "28px" }} value="Branch">Branch</Radio>
                          <Radio style={{ paddingRight: "28px" }} value="Independent Office">Independent Office</Radio>
                          <Radio style={{ paddingRight: "28px" }} value="Independent Directorate" >Independent Directorate</Radio>
                        </Radio.Group>
                      </Form.Item>

                      <Row style={{ marginTop: "30px" }}>
                        <Col span={departmentType == 'Branch' ? 10 : 11}>
                          {departmentType == 'Branch' &&
                            <Form.Item
                              name="b_name"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select branch!',
                                },
                              ]}
                              requiredMark={'optional'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Branch*</p>}
                            >
                              <Select disabled={disbaledRemaningItems} options={getBranches()} defaultActiveFirstOption={true} onChange={getDirectorate}>
                              </Select>
                            </Form.Item>
                          }

                          {departmentType == 'Independent Office' &&
                            <Form.Item
                              name="io_name"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select independent office!',
                                },
                              ]}
                              requiredMark={'optional'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Independent Office*</p>}
                            >
                              <Select disabled={disbaledRemaningItems} options={getIndependentOffices()} defaultActiveFirstOption={true} >
                              </Select>
                            </Form.Item>
                          }

                          {departmentType == 'Independent Directorate' &&
                            <Form.Item
                              name="id_name"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select independent directorate!',
                                },
                              ]}
                              requiredMark={'optional'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Independent Directorate*</p>}
                            >
                              <Select disabled={disbaledRemaningItems} options={getIndependentDirectorates()} defaultActiveFirstOption={true} >
                              </Select>
                            </Form.Item>
                          }

                        </Col>
                        {departmentType == 'Branch' &&
                          <Col span="1"></Col>
                        }
                        <Col span="11">
                          {departmentType == 'Branch' &&
                            <Form.Item
                              name="bd_name"
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: 'Please select directorate!',
                              //   },
                              // ]}
                              requiredMark={'optional'}
                              label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Directorate</p>}
                            >
                              <Select disabled={disbaledRemaningItems} options={directoratesOption} defaultActiveFirstOption={true} value={directorateval} onChange={(v) => setDirectorateVal(v)} >
                                {/* <Option value="Clerk">Clerk</Option>
                                          <Option value="DD's & AD's">DD's & AD's</Option>
                                          <Option value="CHD">CHD</Option> */}
                              </Select>
                            </Form.Item>
                          }
                        </Col>
                        <Col span="2"></Col>
                      </Row>
                    </Form.Item>



                    {/* <Form.Item style={{ marginTop: 25 }}>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                          marginTop: 15,
                        }}
                      >
                       Assign Permission for selected user type Clerk
                      </h2>

                        <Form.Item>
                          <CheckboxGroup
                          className="customadduserCheckboxcss"
                            options={assignPermissionTabOptions}
                            value={checkedList}
                            onChange={onChange}
                            disabled
                          />
                         </Form.Item>

                    </Form.Item> */}


                    {/* </Form> */}
                  </Col>
                  <Col span="2"></Col>
                </Row>

                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",
                    marginBottom: 10,
                  }}
                >
                  <Col span="6"></Col>
                  <Col span="13" style={{ textAlign: "right", paddingRight: 20 }}>
                    <Space>
                      <Link to="/manage-users">
                        <Button type="primary" size="large" ghost>
                          Cancel
                        </Button>
                      </Link>
                      {hideSubmitBtn && <Button htmlType="submit" type="primary" size="large">
                        Submit
                      </Button>
                      }
                    </Space>
                  </Col>
                  <Col span="5"></Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
